import React from 'react';
import './Pettables.css';
import shortweig1 from '../../../imgs/shortweig1.webp';

const Pettables = () => {
  const data = [
    { ton: '160 Ton', models: [{ img: shortweig1, label: 'PET800' }] },
    { ton: '200 Ton', models: [
      { img: shortweig1, label: 'PET850' },
      { img: shortweig1, label: 'PET851' },
     
      
    ]},
    { ton: '288 Ton', models: [
      { img: shortweig1, label: 'PET1205' },
      { img: shortweig1, label: 'PET1500' },
      
    ]},
    { ton: '330 Ton', models: [
      { img: shortweig1, label: 'PET1505' },
      { img: shortweig1, label: 'PET2100' },
    ]},
    { ton: '400 Ton', models: [
      { img: shortweig1, label: 'PET2105' },
      { img: shortweig1, label: 'PET2605L' },
      { img: shortweig1, label: 'PET3105L' },
            { img: shortweig1, label: 'PET4500L' },

    ]},
   
    { ton: '500 Ton', models: [
      { img: shortweig1, label: 'PET3550' },
      { img: shortweig1, label: 'PET5005' },
      { img: shortweig1, label: 'PET8000' },
    ]},
  ];

  return (
    <div className="container">
      <div className='petsort-container'>
         <h2>PET Series</h2>
      </div>
     
      <table className="pet-table">
        <thead>
          <tr>
            <th  className="black-column">Ton</th>
            <th  className="black-column" colSpan="4">Shot Weight: 800g to 8000g</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => {
            const modelCells = row.models.slice(0, 4).map((model, i) => (
              <td key={i}>
                <div className="img-model" data-aos="fade-down">
                  <img src={model.img} alt={model.label} className="petsort-img" />
                  <div className="model-label">{model.label}</div>
                </div>
              </td>
            ));

            while (modelCells.length < 4) {
              modelCells.push(<td key={`empty-${modelCells.length}`}></td>);
            }

            return (
              <tr key={rowIndex}>
                <td  className="black-column">{row.ton}</td>
                {modelCells}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Pettables;
